import React, { Component } from "react";
import {
	handleChangeFilterStatements,
	openOrCloseExportModal,
	openOrCloseFilterModal
} from "../../../actions/sales";

import Button from "../../../../shared/button/button";
import SalePaymentStatusTab from "./SalePaymentStatusTab";
import SalePaymentModalityTab from "./SalePaymentModalityTab";
import SearchWebOrMobile from "../../../../shared/Search/SearchWebOrMobile";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PaginationSelectNumberOfResultsPerPage from "../../../../shared/Pagination/PaginationSelectNumberOfResultsPerPage";
import SearchWeb from "../../../../shared/Search/SearchWeb";

class MySalesActions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpenPaginationSelectNumberOfResultsPerPage: false
		};
	}

	openFilter = () => {
		this.props.openOrCloseFilterModal(true);
	};

	openPaginationSelectNumberOfResultsPerPage = event => {
		this.setState({
			isOpenPaginationSelectNumberOfResultsPerPage: !this.state
				.isOpenPaginationSelectNumberOfResultsPerPage
		});
	};

	changePaginationSelectNumberOfResultsPerPage = nextNumberOfResults => {
		this.props.handleChangeFilterStatements(
			this.props.filteredStatements,
			{ salesPerPage: nextNumberOfResults },
			true
		);
		this.openPaginationSelectNumberOfResultsPerPage();
	};

	// Monitora os clickes fora do componente de paginacao para que quando seja clicado fora o mesmo feche.
	evtClickListener = document.addEventListener("click", evt => {
		const element = document.getElementById("PaginationSelectNumberOfResultsPerPage");
		let targetElement = evt.target; // clicked element

		do {
			if (targetElement === element) {
				// This is a click inside. Do nothing, just return.
				this.setState({
					isOpenPaginationSelectNumberOfResultsPerPage: true
				});
				return;
			}

			if (this.state.isOpenPaginationSelectNumberOfResultsPerPage) {
				this.setState({
					isOpenPaginationSelectNumberOfResultsPerPage: false
				});
			}
			// Go up the DOM
			targetElement = targetElement.parentNode;
		} while (targetElement);
	});

	render() {
		return (
			<div className="my-sales-actions">
				{!this.props.searchIsOpen && (
					<div className="my-sales-actions--container">
						<SalePaymentStatusTab />
						<SalePaymentModalityTab />
					</div>
				)}
				<div
					className={`my-sales-actions--buttons ${
						this.props.searchIsOpen ? "my-sales-actions__is-open--buttons" : ""
					}`}
				>
					{!this.state.isOpenPaginationSelectNumberOfResultsPerPage && (
						<SearchWeb isOpen={this.state.isOpenSearch} />
					)}
					<PaginationSelectNumberOfResultsPerPage
						isOpen={this.state.isOpenPaginationSelectNumberOfResultsPerPage}
						handleOpenOrCloseActions={event =>
							this.openPaginationSelectNumberOfResultsPerPage(event)
						}
						handleChangeNumberOfResults={this.changePaginationSelectNumberOfResultsPerPage}
						activeNumberOfResults={this.props.filteredStatements.salesPerPage}
						id="PaginationSelectNumberOfResultsPerPage"
					/>
					<div>
						<Button
							className="btn-gray-md-icon"
							onClick={this.openFilter}
							data-action="my-sales-action-filter"
						>
							<i className="icon-filter" />
						</Button>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	searchIsOpen: state.mySales.searchIsOpen,
	filteredStatements: state.mySales.filteredStatements
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			openOrCloseFilterModal,
			handleChangeFilterStatements
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(MySalesActions);
